const configs = {
  // 用于电源控制器的区间
  containerPadding: 140,

  // containerPaddingWithCircle: 900,

  powerWidth: 80,
  powerHeight: 120,

  daban: {
    stroke: '#494949',
    strokeWidth: 1,
    // cornerRadius: [10, 10, 10, 10],
    dash: [3, 3],
  },

  accessHole: {
    margin: 5,
    padding: 5,
    cornerRadius: [20, 20, 20, 20],
    stroke: '#d8d8d8',
    strokeWidth: 3,
    dash: [10, 5],
  },

  block: {
    width: 12,
    height: 12,
    margin: 12,
    marginX: 12,
    marginY: 12,
    padding: 3,
    fill: '#d8d8d8'
  },

  line: {
    stroke: 'black',
    strokeWidth: 2,
    lineCap: 'round',
    lineJoin: 'round'
  },

  power: {
    width: 22,
    height: 22,
    iconSize: 18,
    fill: 'rgba(243, 255, 243, 0.9)',
    textFill: '#FF9833',
    cornerRadius: 3,
    gap: 6,
    stroke: 'black',
    strokeWidth: 1,
  },

  controller: {
    width: 36,
    height: 22,
    iconSize: 18,
    fillMain: 'rgba(255, 250, 245, 0.9)',
    fillCong: 'rgba(255, 255, 243, 0.9)',
    textFillMain: '#FF9833',
    textFillCong: '#FFCC00',
    cornerRadius: 3,
    gap: 6,
    stroke: 'black',
    strokeWidth: 1,
    fontSize: 10,
  },

  singleChannelController: {
    width: 36,
    height: 22,
    iconSize: 18,
    fillDanlu: 'rgba(255, 250, 245, 0.9)',
    textFill: '#333',
    cornerRadius: 3,
    gap: 6,
    stroke: 'black',
    strokeWidth: 1,
    fontSize: 10,
  },

  association: {
    width: 48,
  },

  annotation: {
    borderPadding: 2,
    iconLabelGap: 2,
    powerControllerGap: 4,
    powerBorderColor: 'rgba(139, 255, 139, 0.9)',
    controllerBorderColor: 'rgba(255, 203, 152, 0.9)',
    countFontSize: 9,
  },

  text: {
    fontSize: 9,
    fontFamily: 'Arial',
    fill: '#333',
    align: 'center',
    margin: 2,
    height: 16,
  }, 

  accessHoleText: {
    fontSize: 14,
    fontFamily: 'Arial',
    fill: '#333',
    align: 'center',
  },

  // 灯珠 px/mm 比例
  pxPerMm: 0.16, // 12px / 75mm
  pxPerMmLine: 0.28, // 12px / 42mm
  pxPerMmP40: 0.48, // 12px / 25mm

  // rectangle_frame 模组物理尺寸配置 (mm)
  frameTypeSizes: {
    '6060': { width: 600, height: 600 },
    '60120': { width: 1200, height: 600 },
    '60180': { width: 1800, height: 600 },
  },

  // Step1 尺寸限制（单位 m）
  minSizeFace: 0.1, // 面模组：长/宽/半径最小值
  minSizeLine: 0.5, // 线模组：长/宽/半径最小值
  /** 灯具模：较短边最小值，组按 SDL 规格 */
  lampModuleMinSize: {
    '6060': { long: 0.6, short: 0.6 },
    '60120': { long: 1.2, short: 0.6 },
    '60180': { long: 1.8, short: 0.6 },
  },

  maxRadius: 7.5, // 圆形最大半径
  maxSizeFaceLong: 50, // 面模组：较长边最大值
  maxSizeLampSide: 20, // 灯具模组：最大值
  maxSizeLineLong: 32, // 线模组：较长边最大值
  maxSizeLineShort: 20, // 线模组：较短边最大值

  /** 左侧电源+控制器标注所需最小留白(px) */
  getLeftAnnotationPaddingPx() {
    const { gap, width: controllerWidth } = this.controller;
    const { width: powerWidth } = this.power;
    const { powerControllerGap } = this.annotation;
    const blockPadding = this.block.padding || 0;

    return gap + controllerWidth + powerControllerGap + powerWidth + blockPadding + 6;
  },

  getMinAnnotationPaddingLeftRatio() {
    return this.getLeftAnnotationPaddingPx() / this.containerPadding;
  },
}

const config = Object.create(configs)

export default config; 